import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import MotorFetcherFactory from '../../fetcher/Fetchers/factory.js'
import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {HttpUserDiscardedAdsRepository} from '../Repositories/HttpUserDiscardedAdsRepository.js'

class AddUserDiscardedAdsUseCase extends UseCase {
  #getCurrentUserService
  #repository
  #userNotLoggedInError

  static create({config}) {
    return new AddUserDiscardedAdsUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config}),
      repository: HttpUserDiscardedAdsRepository.create({
        config,
        authenticationFetcher: MotorFetcherFactory.httpAuthenticationFetcher({config})
      }),
      userNotLoggedInError: UserErrorsFactory.userNotLoggedInUserError
    })
  }

  constructor({getCurrentUserService, repository, userNotLoggedInError}) {
    super()
    this.#getCurrentUserService = getCurrentUserService
    this.#repository = repository
    this.#userNotLoggedInError = userNotLoggedInError
  }

  @tracer({metric: 'AddUserDiscardedAdsUseCase#execute'})
  @AsyncInlineError()
  async execute({adId}) {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity)
      return Promise.reject(
        this.#userNotLoggedInError({message: '[AddUserDiscardedAdsUseCase#execute] User is not logged in'})
      )

    const userId = userEntity.getId()

    await this.#repository.addDiscardedAd({adId, userId})

    return true
  }
}

export const factory = AddUserDiscardedAdsUseCase.create
